const translation = {
  routesGroup: {
    home: '首頁',
    iaas: 'IaaS',
    containerService: '容器服務',
    ai: '人工智能',
    others: '其他',
    systemSetting: '網站設置',
  },
  // routes title keys
  dashboard: 'Dashboard',
  compute: 'Compute',
  instancesAndImages: 'Instances & Images',
  vm: 'VM Instance',
  baremetal: 'Bare Metal',
  instanceGroup: 'Instance Group',
  serverTemplate: 'Server Template',
  scalingGroup: 'Scaling Group',
  webApp: 'Web App',
  systemImage: 'System Image',
  hostImage: 'Host Image',
  storageAndBackup: 'Storage & Backup',
  disk: 'Disk',
  diskSnapshot: 'Disk Snapshot',
  instanceSnapshot: 'Instance Snapshot',
  snapshotPolicy: 'Snapshot Policy',
  diskBackup: 'Disk Backup',
  instanceBackup: 'Instance Backup',
  networkAndSecurity: 'Network & Security',
  secGroup: 'Security Group',
  subnet: 'Subnet',
  eip: 'EIP',
  tapService: 'Tap Service',
  keypair: 'Key Pair',
  resourceAndSchedule: 'Resource & Schedule',
  sku: 'SKU',
  host: 'Host',
  physicalMachine: 'Physical Machine',
  gpu: 'GPU',
  schedTag: 'Sched Tag',
  schedPolicy: 'Sched Policy',
  dynamicSchedTag: 'Dynamic Sched Tag',
  recycleBin: 'Recycle Bin',
  serverRecovery: 'Server Recovery',
  diskRecovery: 'Disk Recovery',
  imageRecovery: 'Image Recovery',
  network: 'Network',
  networkPlan: 'Network Plan',
  region: 'Region',
  zone: 'Zone',
  baseNetwork: 'Base Network',
  vpcInterconnect: 'VPC Interconnect',
  vpcPeer: 'VPC Peer',
  globalVpc: 'Global VPC',
  vpc: 'VPC',
  routeTable: 'Route Table',
  wire: 'Wire',
  networkService: 'Network Service',
  nat: 'NAT Gateway',
  dns: 'DNS',
  ipv6: 'IPv6 Gateway',
  networkSecurity: 'Network Security',
  waf: 'WAF',
  sshProxy: 'SSH Proxy',
  sshProxyNode: 'Proxy Node',
  sshProxyService: 'Proxy Service',
  lb: 'Load Balancer',
  lbInstance: 'LB Instance',
  lbAcl: 'LB ACL',
  lbCert: 'LB Certificate',
  lbCluster: 'LB Cluster',
  lbClusterMain: 'Cluster Main',
  lbClusterNode: 'Cluster Node',
  cdn: 'CDN',
  cdnDomain: 'CDN Domain',
  storage: 'Storage',
  blockStorage: 'Block Storage',
  workload: 'Workload',
  stateless: 'Stateless',
  stateful: 'Stateful',
  daemonset: 'DaemonSet',
  job: 'Job',
  cronjob: 'CronJob',
  pod: 'Pod',
  pvc: 'PVC',
  imageRepo: 'Image Repo',
  serviceDiscovery: 'Service Discovery',
  service: 'Service',
  ingress: 'Ingress',
  configManage: 'Config Manage',
  configmap: 'ConfigMap',
  secret: 'Secret',
  clusterManage: 'Cluster Manage',
  node: 'Node',
  storageClass: 'Storage Class',
  namespace: 'Namespace',
  role: 'Role',
  clusterRole: 'Cluster Role',
  roleBinding: 'Role Binding',
  clusterRoleBinding: 'Cluster Role Binding',
  serviceAccount: 'Service Account',
  kubeComponent: 'Kube Component',
  federatedCluster: 'Federated Cluster',
  federatedNamespace: 'Federated Namespace',
  federatedRole: 'Federated Role',
  federatedClusterRole: 'Federated Cluster Role',
  federatedRoleBinding: 'Federated Role Binding',
  federatedClusterRoleBinding: 'Federated Cluster Role Binding',
  ml: '機器學習',
  maasServiceNav: '模型服務',
  aiMarket: 'AI市場',
  computeMarket: '算力市場',
  modelMarket: '模型廣場',
  experienceCenter: '體驗中心',
  trainAndInference: '訓練與推理',
  devMachine: '開發機',
  trainTask: '訓練任務',
  trainTemplate: '訓練模版',
  inferenceService: '推理服務',
  aiAssets: 'AI資產',
  dataset: '數據集',
  modelManage: '模型管理',
  containerImage: '容器鏡像',
  repository: '鏡像倉庫',
  diskStorage: '磁盤存儲',
  resourceQuota: '資源配額',
  resourceMonitor: '資源監控',
  resourceAudit: '資源審計',
  modelService: '模型服務',
  modelMarketGroup: '模型廣場',
  modelServiceGroup: '模型服務',
  modelServiceSettingGroup: '系統設置',
  usageStatistics: '用量統計',
  serviceList: '服務價格',
  apiKey: 'API Key',
  systemSetting: '系統設置',
  serviceSetting: '服務設置',
  modelServicePrices: '模型服務價格',
  apiKeyMgmt: 'API Key 管理',
  computeCluster: '計算集群',
  resourceDashboard: '資源大盤',
  storageCluster: '存儲集群',
  modelServiceSetting: '模型服務',
  dataManage: '數據管理',
  containerInstance: '容器實例',
  modelList: '模型列表',
  modelTrain: '模型訓練',
  modelInference: '模型推理',
  auditLog: '審計日誌',
  aiAppBuild: 'AI應用構建',
  knowledgeBase: '知識庫',
  appBuild: '應用構建',
  appMarket: '應用市場',
  monitoringAndOperations: '監控與運維',
  overview: '總覽',
  resource: '資源',
  monitorVM: 'Monitor VM',
  monitorHost: 'Monitor Host',
  monitorMetric: 'Monitor Metric',
  monitorDashboard: 'Monitor Dashboard',
  monitorQuery: 'Monitor Query',
  alert: 'Alert',
  alertPolicy: 'Alert Policy',
  alertHistory: 'Alert History',
  alertResource: 'Alert Resource',
  alertPolicy2: 'Resource Alert Policy',
  authenticationAndSecurity: '認證與安全',
  authSystem: 'Auth System',
  authIdp: '認證域',
  authDomain: '域',
  authProject: 'Auth Project',
  authGroup: 'Auth Group',
  authUser: 'Auth User',
  authRole: 'Auth Role',
  authPolicy: 'Auth Policy',
  securityAlert: 'Security Alert',
  messageCenter: 'Message Center',
  messageSubscribeSetting: 'Message Subscribe Setting',
  notifyChannelSetting: 'Notify Channel Setting',
  contactManage: 'Contact Manage',
  robotManage: 'Robot Manage',
  systemSetting2: 'System Setting',
  websiteSetting: 'Website Setting',
  licenseSetting: 'License Setting',
}
export default translation;